// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";

export const mantineAreaChartPropsSchema = z.object({
	h: z.number().optional(),
});
